module.exports = __webpack_public_path__ + "img/vi-logo-3p.7f02c87d.png";